var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "PhonenumberInput form-group"
  }, [_c('label', {
    staticClass: "font-weight-bold",
    attrs: {
      "for": _vm.id,
      "data-qa": _vm.qa + '.label'
    }
  }, [_vm._t("default")], 2), _c('vue-phone-number-input', {
    attrs: {
      "id": _vm.id,
      "data-qa": _vm.qa + '.input',
      "required": _vm.required,
      "noExample": true,
      "defaultCountryCode": _vm.country,
      "translations": {
        countrySelectorLabel: '',
        countrySelectorError: '',
        phoneNumberLabel: ''
      }
    },
    on: {
      "update": _vm.updatePhoneNumber
    },
    model: {
      value: _vm.phoneNumber,
      callback: function ($$v) {
        _vm.phoneNumber = $$v;
      },
      expression: "phoneNumber"
    }
  }), _c('div', {
    staticClass: "PhonenumberInput-error",
    class: {
      'PhonenumberInput-error--displayed': _vm.errorLabel !== ''
    },
    attrs: {
      "id": 'js-error-' + _vm.inputId,
      "aria-label": _vm.errorLabel,
      "tabindex": _vm.getErrorTabIndex
    }
  }, [_vm._v(" " + _vm._s(_vm.errorLabel) + " ")]), _c('input', {
    staticStyle: {
      "opacity": "0",
      "width": "0",
      "float": "left"
    },
    attrs: {
      "type": "text",
      "required": !_vm.isValid,
      "value": ""
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }